import styled, { css } from "styled-components"
import Image from "components/atoms/Image"

const blockHeadingStyles = css`
  overflow: hidden;
  text-overflow: ellipsis;

  /* stylelint-disable */
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  /* stylelint-enable */
`

const blockTextStyles = css`
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: ${({ theme }) => theme.font.size.s};
  line-height: 1.71;
  color: ${({ theme }) => theme.color.secondary01};
  margin: 0.8rem 0;
  height: 7.2rem;
  hyphens: auto;
  text-align: justify;

  /* stylelint-disable */
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  /* stylelint-enable */
`
const StyledListBlock = styled.div`
  margin-bottom: 3.2rem;
`

const StyledBlockImage = styled(Image)`
  width: 100%;
  object-fit: cover;
  height: 19.2rem;
  margin-bottom: 0.8rem;

  ${({ theme }) => theme.mq.medium} {
    height: 20.8rem;
  }
`

const linkButtonStyles = css`
  color: ${({ theme }) => theme.color.main03};
  font-weight: ${({ theme }) => theme.font.weight.semiBold};
  font-size: ${({ theme }) => theme.font.size.s};
  cursor: pointer;
  margin: 0.8rem 0 0 auto;
  display: block;
  width: max-content;

  &:hover,
  &:active {
    text-decoration: underline;
  }
  &:active {
    color: ${({ theme }) => theme.color.main02};
  }
`

export {
  blockHeadingStyles,
  blockTextStyles,
  StyledListBlock,
  StyledBlockImage,
  linkButtonStyles,
}
